import axios from 'axios';
import axiosRetry from 'axios-retry';
import qs from 'qs';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import authServices from './auth.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

function verifyUser(){
  return JSON.parse(localStorage.getItem('auth'));
}

export const resetForms = () => async (dispatch) => {
  dispatch({
    type: actions.FORM_FAIL,
    payload: "",
  });
  dispatch({
    type: actions.FORM_PASSWORD_FAIL,
    payload: "",
  });
}

export const getAuth = () => async (dispatch) => {
  const oAuth = verifyUser();
  dispatch({
    type: actions.GET_TOKEN,
    payload: {
      userId: oAuth ? oAuth.userId : '',
      token: oAuth ? oAuth.token : '',
      username: oAuth ? oAuth.username : '',
      id: oAuth ? oAuth.id : '',
      name: oAuth ? oAuth.name : '',
      userRoles: oAuth ? oAuth.userRoles : '',
      pic: oAuth ? oAuth.pic : '',
      unidOrg: oAuth ? oAuth.unidOrg : null,
      unidName: oAuth ? oAuth.unidName : '',
      userOrg: oAuth ? oAuth.userOrg : null,
      userUpdated: oAuth ? oAuth.userUpdated: false,
      userType: oAuth ? oAuth.userType : -1,
    }
  });
}

export const singIn = (data, props) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    //let token = '';
    let oAuth = verifyUser();
    if(!oAuth || oAuth.username !== data.username){
      const resp = await client.post('/api/token',
      qs.stringify(data),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
      
      const respUserInfo = await client.get('/api/app/Formal_User_Data/', {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${resp.data.token}`
        }
      });
  
      oAuth = {
        userId: respUserInfo.data.empleado[0].id_user,
        token: resp.data.token, 
        username: respUserInfo.data.empleado[0].username,
        id: respUserInfo.data.empleado[0].id,
        name: respUserInfo.data.empleado[0].nombre,
        userRoles: respUserInfo.data.empleado[0].grupo,
        pic: respUserInfo.data.empleado[0].foto ? `${process.env.REACT_APP_URL}/media/${respUserInfo.data.empleado[0].foto}` : null,
        unidOrg: respUserInfo.data.unidad[0].id,
        unidName: respUserInfo.data.unidad[0].nombre,
        userOrg: respUserInfo.data.empresa[0].id,
        userUpdated: respUserInfo.data.empleado[0].actualizado,
        userType: parseInt(respUserInfo.data.estructura)
      };
      localStorage.setItem('auth', JSON.stringify(oAuth));
    }
    
    await client.post('/api/app/LLenar_Log_SessionViewset/',{}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${oAuth.token}`
      }

    });
    
    dispatch({
      type: actions.GET_TOKEN,
      payload: oAuth
    });

    if(oAuth.userUpdated){
      props.history.push(`/detalle-empleado/${oAuth.id}/${oAuth.userType}`);
    }else{
      props.history.push('/recordatorio-actualizacion');
    }
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        toastr.error("Error al iniciar sesión, verifique sus credenciales y vuelva a intentarlo");
        // if(Array.isArray(ex.response.data)){
        //   ex.response.data.forEach(item => {
        //     toastr.error(item);
        //   });
        // }else{
        //   toastr.error(ex.response.data);
        // }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_AUTH,
      payload: false
    });
  }
}

export const singOut = () => async (dispatch, getState) => {
  try {
    const { token } = getState().auth;
    await client.post('/api/app/logout/', { token: token });
    localStorage.removeItem('auth');
    dispatch({
      type: actions.GET_TOKEN,
      payload: {
        token: '',
        username: ''
      }
    });
    //window.location.href = "/";
    //props.history.push('/');
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }
}

//accion del link de la pantalla de login de olvidar contraseña
export const sendEmail = email => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    //const resp = await client.post('/api/app/sendmail/', {correo: email});
    await client.post('/api/app/sendmail/', {correo: email});
    dispatch({
      type: actions.RECOVER_PASS,
      payload: true
    });
    // props.history.push('/');
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_AUTH,
      payload: false
    });
  }
}  


//accion despues de revisar el correo que manda el recoverpass 
export const changePassword = data => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    //const resp = await client.post(`/api/app/resetpassword/`, data)
    await client.post(`/api/app/resetpassword/`, data);
    //const { username, password, new_password  } = getState().auth;
    // dispatch({
    //   type: actions.RESET_PASS,
    //   payload: {
    //     username: username,
    //     password: password,
    //     new_password: new_password
    //   }
    // });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_AUTH,
      payload: false
    });
  }
}

export const getUsers = (params) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(`/api/app/User/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await authServices.getUsers(params);
    // const respRoles = await client.get('/api/app/Group/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }
    // });
    const respRoles = await authServices.getGroups();
    dispatch({
      type: actions.GET_USERS,
      payload: {
        users: resp.data.data,
        usersLength: resp.data.count,
        roles: respRoles.data.data
      }
    });
    dispatch({
      type: actions.USER_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.USER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
         type: actions.LOADING_AUTH,
      payload: false
    });
  }
}

export const resetListUsers = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    dispatch({
      type: actions.GET_USERS,
      payload: {
        users: [],
        usersLength: 0
      }
    });
    dispatch({
      type: actions.USER_FAIL,
      payload: "",
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
         type: actions.LOADING_AUTH,
      payload: false
    });
  }
}

export const saveUser = (data, setShowModal, setGroupsVal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_lOADER_USER,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const isUserValid = await checkUser(data.username, data.email);
    if(isUserValid) {
      // const resp = await client.post('/api/app/User/', data, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Authorization': `Token ${token}`
      //   }});
      const resp = await authServices.saveUser(data);
      const { users, usersLength, roles } = getState().auth;
      const aUsers = [...users, resp.data];
      dispatch({
        type: actions.GET_USERS,
        payload: {
          users: aUsers,
          usersLength: usersLength + 1,
          roles: roles
        }
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      setGroupsVal([]);
      toastr.success(messages.successMessage);
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_lOADER_USER,
      payload: false
    });
  }
}

export const editUser = (data, id, index, setShowModal, setGroupsVal, setSaveLoading) => async (dispatch, getState) => {
  try {
    if(setSaveLoading){
      setSaveLoading(true)
    }else{
      dispatch({
        type: actions.SAVE_lOADER_USER,
        payload: true
      });
    }
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(`/api/app/User/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await authServices.editUser(id, data);
    const { users, usersLength, roles  } = getState().auth;
    users[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_USERS,
      payload: {
        users: users,
        usersLength: usersLength,
        roles: roles
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    if(setShowModal){
      setShowModal(false);
    }
    if(setGroupsVal){
      setGroupsVal([]);
    }
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    if(setSaveLoading){
      setSaveLoading(false)
    }else{
      dispatch({
        type: actions.SAVE_lOADER_USER,
        payload: false
      });
    }
  }
}

export const deleteUser = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(`/api/app/User/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await authServices.deleteUser(id);
    const { users, usersLength, roles } = getState().auth;
    users.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_USERS,
      payload: {
        users: users,
        usersLength: usersLength -1,
        roles: roles
      }
    });
    dispatch({
      type: actions.USER_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = ex.response.data.mensaje;
            }
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.USER_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_AUTH,
      payload: false
    });
  }
}


export const getUsersData = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_AUTH,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`api/app/Formal_empleado/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      // params: data
    });
    
    dispatch({
      type: actions.GET_FORMAL_FICHA,
      payload: resp.data
    });
  } catch (ex) {
    errorManage(ex);
  }finally{
    dispatch({
         type: actions.LOADING_AUTH,
      payload: false
    });
  }
}

async function checkUser(username, email) {
  let valid = false;
  try {
    // await client.get(`/api/app/Existe_Correo/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: {
    //     username: username,
    //     email: email
    //   }
    // });
    await authServices.checkUser({
      username: username,
      email: email
    });
    valid = true;
  }catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else if(ex.response.status === 404){
        toastr.error('El registro ya existe');
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
    console.error(ex.response.data);
  }
  return valid;
}

/*export const evaluateUsers = (data,edit,reqEdit,editItem) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_VERIFICATION,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Existe_Correo/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: {
        username: data.username,
        email: data.email
      }
    });
    dispatch({
      type: actions.GET_VERIFICATION,
      payload: {
        verifUserName: resp.data.mensaje_username,
        verifEmail: resp.data.mensaje_email
      }
    });
    const { verifUserName, verifEmail } = getState().auth;

    if(!edit){
      if(verifUserName==='Usuario ya existe' && verifEmail==='Correo ya existe' && editItem.email!==data.email && editItem.username!==data.username){
        toastr.error('El usuario ya existe');
        toastr.error('El correo ya existe');
      }else if(verifUserName==='' && verifEmail==='Correo ya existe' && editItem.email!==data.email){
        toastr.error('El correo ya existe');
      }else if(verifUserName==='Usuario ya existe' && verifEmail==='' && editItem.username!==data.username){
        toastr.error('El usuario ya existe');
      }else if(verifUserName==='' && verifEmail===''){
        dispatch(editUser(data, reqEdit.editItem, reqEdit.index));
      }
    }else{
      if(verifUserName==='Usuario ya existe' && verifEmail==='Correo ya existe' && editItem.email===data.email && editItem.username===data.username){
        dispatch(editUser(data, reqEdit.editItem, reqEdit.index));
      }else if(verifUserName==='' && verifEmail==='Correo ya existe' && editItem.email===data.email){
        dispatch(editUser(data, reqEdit.editItem, reqEdit.index));
      }else if(verifUserName==='Usuario ya existe' && verifEmail==='' && editItem.username===data.username){
        dispatch(editUser(data, reqEdit.editItem, reqEdit.index));
      }else if(verifUserName==='' && verifEmail===''){
        dispatch(editUser(data, reqEdit.editItem, reqEdit.index));
      }else{
        toastr.error('No se pudo modificar el usuario');
      }
    }
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
         type: actions.LOADING_VERIFICATION,
      payload: false
    });
  }
}*/

export const resetPassword = (data, setShowModalPassword) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_RESET_PASS,
      payload: true
    });
    //const resp = await client.post(`/api/app/resetpassword/`, data)
    // const resp = await client.post(`/api/app/admin_reset_password/`, data);
    const resp = await authServices.resetPassword(data);
    //const { username, password, new_password  } = getState().auth;
    // dispatch({
    //   type: actions.RESET_PASS,
    //   payload: {
    //     username: username,
    //     password: password,
    //     new_password: new_password
    //   }
    // });
    const _resp = resp.data;
    dispatch({
      type: actions.FORM_PASSWORD_FAIL,
      payload: "",
    });
    setShowModalPassword(false)
    toastr.success(_resp.mensaje?_resp.mensaje:messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(Array.isArray(ex.response.data)){
              ex.response.data.forEach(item => {
                toastr.error(item);
              });
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_PASSWORD_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADER_RESET_PASS,
      payload: false
    });
  }
}

export const addUser = (user) => async (dispatch) => {
  dispatch({
    type: actions.ADD_USER,
    payload: user
  });
}